import { render, staticRenderFns } from "./StudentDataTable.vue?vue&type=template&id=12c1ad6d&scoped=true&"
import script from "./StudentDataTable.vue?vue&type=script&lang=js&"
export * from "./StudentDataTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentDataTable.vue?vue&type=style&index=0&id=12c1ad6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c1ad6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VIcon,VTooltip})
